import React, { useState, useEffect, useCallback } from 'react';
import { FiMessageSquare } from 'react-icons/fi';

const HEALTH_URL = 'https://v1-csapi.compsoft.com.br:3003/health';
const INTERVAL   = 30000;

const BotStatus = () => {
  const [status, setStatus] = useState(null); // null=verificando, true=on, false=off
  const [nome,   setNome]   = useState('Casa Imob.');

  const check = useCallback(async () => {
    try {
      const controller = new AbortController();
      const tid = setTimeout(() => controller.abort(), 8000);
      const res = await fetch(HEALTH_URL, { signal: controller.signal });
      clearTimeout(tid);
      if (res.ok) {
        const data = await res.json();
        if (data.nome) setNome(data.nome);
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch {
      setStatus(false);
    }
  }, []);

  useEffect(() => {
    check();
    const t = setInterval(check, INTERVAL);
    return () => clearInterval(t);
  }, [check]);

  const dotClass  = status === null ? 'cs-dot cs-dot-idle'
    : status ? 'cs-dot cs-dot-on'
    : 'cs-dot cs-dot-off';
  const badgeColor = status === null ? '#9ca3af' : status ? '#10b981' : '#ef4444';
  const badgeText  = status === null ? '...'     : status ? 'ON'      : 'OFF';

  return (

     <div className="cs-item">
        <span className="cs-item-label">
          <span className="cs-item-icon"><FiMessageSquare size={13} /></span>
          {nome.slice(0,10)}
        </span>
        <span className="cs-ping-status">
          <span className={dotClass.slice(0, 10)} />
          <span className="cs-server-badge" style={{ color: badgeColor }}>{badgeText}</span>
        </span>
      </div>
  );
};

export default BotStatus;
